import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { createQueryKey } from '@/lib/react-query'
import OfferActionService from '../services/offerAction.service'

/**
 * Offer Action contain all the action that can be done on a single offer
 * @returns
 */
const useOfferAction = () => {
  const service = new OfferActionService()
  const queryClient = useQueryClient()
  const queryKey = createQueryKey(API_RESOURCE.OFFER)

  const useAdminEditOffer = () => {
    return useMutation({
      mutationFn: service.adminEditOffer,
      onSuccess: (res) => {
        toast.info(`Successfully Admin Edit Offer`)
        queryClient.invalidateQueries(queryKey.lists())
        if (res?._id) {
          queryClient.invalidateQueries(queryKey.detail(res?._id))
        }
      },
      onError: (error) => {
        if (error.message) {
          toast.error(error.message)
        }
      },
    })
  }

  const useReviseOffer = () => {
    return useMutation({
      mutationFn: service.reviseOffer,
      onSuccess: (res) => {
        toast.info(`Successfully Revise Offer`)
        queryClient.invalidateQueries(queryKey.lists())
        if (res?._id) {
          queryClient.invalidateQueries(queryKey.detail(res?._id))
        }
      },
      onError: (error) => {
        if (error.message) {
          toast.error(error.message)
        }
      },
    })
  }

  const useAddCustomerToOffer = useAction({
    mutationFn: service.addCustomerToOffer,
    queryKey: queryKey,
    message: 'Successfully Added Customer to Offer',
  })
  const useCloneOffer = useAction({
    mutationFn: service.cloneOffer,
    queryKey: queryKey,
    message: 'Successfully Cloned Offer',
  })
  const useRenewOffer = useAction({
    mutationFn: service.renewOffer,
    queryKey: queryKey,
    message: 'Successfully Renewed Offer',
  })
  const useCreateOfferBooking = useAction({ mutationFn: service.createOfferBooking, queryKey: queryKey })

  const useNoticeCurrentApprover = useAction({
    mutationFn: service.noticeCurrentApprover,
    queryKey: queryKey,
    message: 'Successfully Notified Current Approver',
  })
  const useActivateOffer = useAction({
    mutationFn: service.activateOffer,
    queryKey: queryKey,
    message: 'Successfully Activated Offer',
  })
  const useToggleOfferRenewalLost = useAction({
    mutationFn: service.toggleOfferRenewalLost,
    queryKey: queryKey,
    // message not needed
  })
  const useUncloseOffer = useAction({
    mutationFn: service.uncloseOffer,
    queryKey: queryKey,
    // message not needed
  })
  const useRemoveOfferFile = useAction({ mutationFn: service.removeOfferFile, queryKey: queryKey })

  return {
    useAdminEditOffer,
    useReviseOffer,
    useCloneOffer,
    useRenewOffer,
    useCreateOfferBooking,
    useNoticeCurrentApprover,
    useActivateOffer,
    useAddCustomerToOffer,
    useToggleOfferRenewalLost,
    useRemoveOfferFile,
    useUncloseOffer,
  }
}

export default useOfferAction
